import { PrintDoc } from '../print/PrintDoc';
import { fmt } from '../shared/badges';

// Décharge A5 remise au fournisseur (ou au chauffeur) contre le versement d'une avance.
export const RecuAvance = ({ avance, onClose }) => (
  <PrintDoc
    format="a5"
    type="Reçu d’avance / acompte fournisseur"
    numero={avance.numero}
    date={avance.date}
    tiers={avance.fournisseur}
    lignes={[
      ['Nature de l’opération', 'Avance / acompte sur factures à venir'],
      ['Mode de paiement', avance.mode],
      ['N° de pièce (chèque / virement)', avance.piece || '—'],
      ['Décaissement', avance.compteNom || '—'],
      ['Déjà imputé sur factures', `${fmt(avance.impute ?? 0, 3)} TND`],
      ['Versé par', avance.par || '—'],
    ]}
    totaux={[
      ['Montant versé', `${fmt(avance.montant, 3)} TND`],
      ['Solde créditeur après versement', `${fmt(avance.reste ?? avance.montant, 3)} TND`],
    ]}
    mentions="Reçu valant décharge : le bénéficiaire reconnaît avoir perçu la somme ci-dessus à titre d’avance, imputable sur ses prochaines factures. Montants en dinars tunisiens (TND)."
    signatures={['Signature & cachet — Huilerie', 'Signature — Bénéficiaire']}
    onClose={onClose}
  />
);
